import PropTypes from 'prop-types'

import { iso8601PropType } from '../common/iso-8601-prop-type'
import { workStatePropType } from './work-state-prop-type'

/**
 * @typedef {Object} CurrentWorkState
 * @property {string} [dailyDrivingTime]         - The daily driving time as ISO 8601 duration string.
 * @property {boolean} [isDailyDrivingTimeValid] - A flag indicating that the field dailyDrivingTime reflects a
 *                                                 meaningful value. For example if a driver appears to be driving for
 *                                                 more than a month the flag will be false. This is a hint that a
 *                                                 client should probably not display the daily driving time then. Exact
 *                                                 rules for this flag are object to business decisions and may change.
 * @property {boolean} [isWorkStateValid]        - A flag indicating that the field workState reflects a meaningful
 *                                                 value. For example if a driver has not changed its work state for
 *                                                 more than 24 hours the flag will be false. This is a hint that a
 *                                                 client should probably not display the work state then. Exact rules
 *                                                 for this flag are object to business decisions and may change.
 * @property {WorkState} workState               - The work state of the driver for the object.
 */
export const currentWorkStatePropType = PropTypes.shape({
    dailyDrivingTime: PropTypes.string,
    isDailyDrivingTimeValid: PropTypes.bool,
    isWorkStateValid: PropTypes.bool,
    workState: workStatePropType.isRequired,
    workStateEventSource: PropTypes.string,
    workStateEventTime: iso8601PropType
})
